import React from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { useIsMobile } from 'hooks/useIsMobile'
import styles from './ContentContainer.module.scss'

export const ContentContainer: React.FC<{ title: string }> = ({
  title,
  children,
}) => {
  const isMobile = useIsMobile()

  return (
    <Card className={`${styles.container} ${isMobile ? styles.mobile : ''}`}>
      <Card.Body className="p-0">
        <Container fluid className={'pl-0'}>
          <Row className={'d-flex align-items-center mb-1'}>
            <Col>
              <h1 className={styles.title}>{title}</h1>
            </Col>
          </Row>
          <Row>
            <Col>{children}</Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  )
}
